// @ts-nocheck
import React from "react";
import { FaGlobe, FaQrcode, FaHotel, FaCode, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { useLanguageContext } from "../context/languageContext";
import clickLogo from "../assets/images/clickapp-logo.svg";

/**
 * "Powered by Click Albania" - the same partner banner the Cialda site carries.
 *
 * Deliberately the only card left in navy: this one is Click Albania's identity,
 * so it does not follow the restaurant's green the way the other banners do.
 *
 * A guest who likes the menu they are holding is the best lead the software side of
 * the business gets, so the banner says who built it, what else they build, and gives
 * a number that dials straight from the phone already in their hand.
 *
 * Everything below comes from clickapp.win itself - none of it is invented.
 */

const CLICK_PHONE = "+355 69 25 70 455";
const CLICK_PHONE_RAW = "355692570455";

export const PartnerBanner = () => {
    const { t } = useLanguageContext();

    const services = [
        { icon: FaGlobe, label: "Website & Web App Development" },
        { icon: FaQrcode, label: "Digital Menu & QR Ordering" },
        { icon: FaHotel, label: "Hotel Management Systems" },
        { icon: FaCode, label: "Custom Business Software" },
    ];

    return (
        <section className="px-4 pt-2 pb-6">
            <div className="text-center mb-4">
                <div className="inline-block px-3 py-1 border border-sand/40 rounded-full mb-2">
                    <span className="text-[9px] font-black uppercase tracking-[0.2em] text-sand">
                        {t("Our Partner", "Our Partner")}
                    </span>
                </div>
                <h2 className="text-lg font-clash text-slate-950 tracking-tight">
                    {t("Powered by", "Powered by")}{" "}
                    {/* Explicit indigo, not the brand token: the rest of the app went
                        green with the logo, and this card stays Click Albania's. */}
                    <span className="italic text-indigo-600">Click Albania</span>
                </h2>
            </div>

            <div className="relative overflow-hidden rounded-[1.25rem] bg-navy shadow-[0_10px_30px_-16px_rgba(11,30,59,0.9)]">
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute -top-20 -right-10 w-56 h-56 rounded-full bg-navy-light opacity-60 blur-[70px]"></div>
                    <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-sand/50 to-transparent"></div>
                </div>

                <div className="relative z-10 p-5">
                    {/* Lockup: the logo is dark navy artwork, so it needs a white plate */}
                    <div className="flex items-center gap-3.5">
                        <div className="flex-shrink-0 bg-white rounded-xl p-2 shadow-[0_6px_18px_-6px_rgba(0,0,0,0.6)]">
                            <img
                                src={clickLogo}
                                alt="Click Albania"
                                width="48"
                                height="48"
                                className="w-12 h-12 object-contain"
                            />
                        </div>

                        <div className="min-w-0 flex-1">
                            <p className="font-clash text-xl text-white leading-tight">
                                Click Albania
                            </p>
                            <p className="text-[9px] font-black uppercase tracking-[0.18em] text-white/50 mt-0.5">
                                {t("Software Company", "Software Company")}
                                <span className="text-white/25 mx-1.5">◆</span>
                                <span className="text-sand">{t("Durrës, Albania", "Durrës, Albania")}</span>
                            </p>
                        </div>
                    </div>

                    <p className="text-[11px] font-medium leading-snug text-white/50 mt-4">
                        {t(
                            "This website and the digital menu you are browsing were designed and built by Click Albania.",
                            "This website and the digital menu you are browsing were designed and built by Click Albania."
                        )}
                    </p>

                    {/* Services as compact rows, not oversized cards */}
                    <div className="grid grid-cols-2 gap-x-3 gap-y-3 mt-5 pt-5 border-t border-white/10">
                        {services.map(({ icon: Icon, label }) => (
                            <div key={label} className="flex items-start gap-2">
                                <Icon className="text-sand flex-shrink-0 mt-[2px]" size={13} />
                                <span className="text-[10.5px] font-medium text-white/85 leading-snug">
                                    {t(label, label)}
                                </span>
                            </div>
                        ))}
                    </div>

                    <div className="mt-5 pt-4 border-t border-white/10 flex items-center gap-1.5 text-[10px] font-medium text-white/45">
                        <FaMapMarkerAlt className="text-sand flex-shrink-0" size={11} />
                        {t("Durrës, Albania", "Durrës, Albania")}
                    </div>

                    <a
                        href={`tel:+${CLICK_PHONE_RAW}`}
                        className="mt-4 flex items-center justify-center gap-2 h-11 rounded-xl bg-sand text-navy text-[11px] font-black uppercase tracking-widest active:scale-[0.98] transition-transform"
                    >
                        <FaPhoneAlt size={11} />
                        {CLICK_PHONE}
                    </a>
                </div>
            </div>
        </section>
    );
};

export default PartnerBanner;
